import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

//datos navegador
import client from "./modules/client";
//topics smartick
import topics from "./modules/topics";

const supportedLanguages = ["es", "en", "br"];

export default new Vuex.Store({
  state: {
    videoCinemaActive: false,
    videoCinemaActiveItem: false,
    videoCinemaPreviewItem: false,
    language: "es",
    initialVideoID: -1,
    initialLoadCompleted: false
  },
  mutations: {
    SET_VIDEOCINEMA_ACTIVE(state, payload) {
      state.videoCinemaPreviewItem = payload.preview;
      state.videoCinemaActive = payload.activo;
      if (payload.activo) state.videoCinemaActiveItem = payload.item;
      else state.videoCinemaActiveItem = {};
    },
    SET_LANGUAGE(state, lang) {
      state.language = lang;
    },
    SET_INITIAL_VIDEOID(state, videoID) {
      state.initialVideoID = videoID;
    },
    SET_INITIAL_LOADCOMPLETED(state, b) {
      state.initialLoadCompleted = b;
    },
  },
  actions: {
    activeVideoCinema: ({ commit }, payload) => {
      commit("SET_VIDEOCINEMA_ACTIVE", payload);
    },
    setLanguage({ commit }, languages) {
      if (typeof languages === "string") {
        commit("SET_LANGUAGE", languages);
      } else {
        const language = supportedLanguages.find(sl =>
          languages.find(l =>
            l.split(new RegExp(sl, "gi")).length - 1 > 0 ? sl : null
          )
        );
        commit("SET_LANGUAGE", language);
      }
    },
    setInitialVideoID({ commit }, videoID) {
        commit("SET_INITIAL_VIDEOID", videoID);
    },
    setLoadComplete({ commit }, b) {
      commit("SET_INITIAL_LOADCOMPLETED", b);
    },
  },
  getters: {
    videoCinemaState: state => state.videoCinemaActive,
    videoCinemaActiveItem: state => state.videoCinemaActiveItem,
    videoCinemaPreviewItem: state => state.videoCinemaPreviewItem,
    language: state => state.language,
    initialVideoIDlanguage: state => state.initialVideoID,
    initialLoadCompleted: state => state.initialLoadCompleted
  },
  modules: {
    topics,
    client
  }
});
